module.exports = __webpack_public_path__ + "static/media/expertise-experience.536431fe.png";